import React from 'react'
import styled from 'styled-components'

const Skills = () => {
  return (
    <StyledSkills>
        <div className="skills-container">
            <div className="skills-header">
                <h1>Skills</h1>
            </div>
            <div className="skills-list">
                <div className="skills-box-1">
                    <ul>
                        <li>HTML</li>
                        <li>CSS</li>
                        <li>JavaScript</li>
                    </ul>
                </div>
                <div className="skills-box-2">
                    <ul>
                        <li>React</li>
                        <li>Angular</li>
                        <li>Typescript</li>
                    </ul>
                </div>
                <div className="skills-box-3">
                    <ul>
                        <li>Redux</li>
                        <li>ReactStrap</li>
                        <li>Styled-Components</li>
                    </ul>
                </div>
            </div>
        </div>
    </StyledSkills>
  )
}

export default Skills

const StyledSkills = styled.div`
    height: 100vh;
    .skills-container{
        position: relative;
     
        .skills-header{
            display: flex;
            justify-content: flex-end;
            padding: 0rem 7.625rem 0rem 7.5rem;
            @media (max-width: 799px) {
                padding: 0rem 5% 0rem 5%;
                justify-content: flex-start;
            }
            h1{
                font-family: 'Space Grotesk', sans-serif;
                font-weight: 500;
                font-size: 7.5rem;
                line-height: 9.5625rem;
                text-transform: uppercase;
                color: #333333;
                @media(max-width: 799px) {
                    font-size: 3.125rem;
                    line-height: 3.9875rem;
                }
            }
        }
        .skills-list{
            display: flex;
            width: 100%;
            border-top: 0.25rem solid #4F4F4F;
            border-bottom:  0.25rem solid #4F4F4F;
            align-items: center;
            @media (max-width: 799px) {
            flex-direction: column;
            border-top: none;
                border-top: 0.25rem solid #4F4F4F;
                border-bottom:  0.25rem solid #4F4F4F;
            }
            .skills-box-2{
                border-right: 0.25rem solid #4F4F4F;
                border-left: 0.25rem solid #4F4F4F;
                @media (max-width: 799px) {
                    border-right: none;
                    border-left: none;
                    border-top: 0.25rem solid #4F4F4F;
                    border-bottom:  0.25rem solid #4F4F4F;
                }
            }
            .skills-box-1, .skills-box-2, .skills-box-3{
                width: 33.3%;
                padding: 8rem 0; 
                @media (max-width: 799px) {
                    width: 100%;
                    padding: 2.1875rem;
                }
                ul{
                    list-style: none;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    li{
                        font-family: 'Nunito', sans-serif;
                        font-weight: 600;
                        font-size: 3.125rem;
                        line-height: 4.25rem;
                        margin-bottom: 0.625rem;
                        
                        @media (max-width: 799px) {
                        font-size: 1.875rem;
                        line-height: 2.5rem;
                    }
                    }
                }
            }
        }
    }
`